import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';
import { MapPin, Building2, Users } from 'lucide-react';

export default function AboutSection() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-100px' });
  const { t } = useLanguage();

  const highlights = [
    { icon: MapPin, label: t('about.highlight1'), desc: t('about.highlight1Desc') },
    { icon: Building2, label: t('about.highlight2'), desc: t('about.highlight2Desc') },
    { icon: Users, label: t('about.highlight3'), desc: t('about.highlight3Desc') },
  ];

  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#0B1120]">
      <div className="max-w-7xl mx-auto" ref={ref}>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          <motion.div initial={{ opacity: 0, x: -30 }} animate={inView ? { opacity: 1, x: 0 } : {}} transition={{ duration: 0.8 }} className="md:col-span-5">
            <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] font-bold mb-4 font-['Outfit']">{t('about.label')}</p>
            <h2 className="text-3xl sm:text-4xl font-light text-[#F8FAFC] font-['Cormorant_Garamond'] tracking-tight leading-tight mb-6">
              {t('about.title1')}<br /><span className="text-[#D4AF37]">{t('about.title2')}</span>
            </h2>
            <div className="w-16 h-px bg-[#D4AF37] mb-6" />
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 30 }} animate={inView ? { opacity: 1, x: 0 } : {}} transition={{ duration: 0.8, delay: 0.2 }} className="md:col-span-7">
            <p className="text-base text-[#94A3B8] font-['Outfit'] leading-relaxed mb-8">{t('about.desc1')}</p>
            <p className="text-base text-[#94A3B8] font-['Outfit'] leading-relaxed mb-10">{t('about.desc2')}</p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              {highlights.map((item, i) => (
                <motion.div key={i} initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.6, delay: 0.4 + i * 0.15 }} className="group">
                  <div className="w-10 h-10 bg-[#D4AF37]/10 border border-[#D4AF37]/20 rounded-sm flex items-center justify-center mb-3 group-hover:bg-[#D4AF37]/20 transition-colors">
                    <item.icon className="w-5 h-5 text-[#D4AF37]" />
                  </div>
                  <h3 className="text-sm font-medium text-[#F8FAFC] font-['Outfit'] mb-1">{item.label}</h3>
                  <p className="text-xs text-[#94A3B8] font-['Outfit']">{item.desc}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
